// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ge6hWf8x{display:flex}._5GeU6tVtx{padding:0 8px 8px;border-bottom:1px solid var(--ui-divider);margin:0 8px 8px 8px}._2vvCoeLRx>._5GeU6tVtx{border-color:rgba(255,255,255,0.1)}@media screen and (-ms-high-contrast: active){._5GeU6tVtx{border-color:windowText}}._6xm4GRsux{padding:4px;padding-left:8px;position:relative;left:-8px}._6WDcsCKmx{background-color:var(--ui-search);border:none}._6WDcsCKmx:focus{border:none;box-shadow:none}._4ybyHWpWx{position:relative;max-height:250px;overflow:auto;padding-bottom:8px}@media (max-height: 250px){._4ybyHWpWx{max-height:calc(100vh - 16px)}._5GeU6tVtx+._4ybyHWpWx{max-height:calc(100vh - 16px - 40px)}}._3rpvMsaJx{border-radius:4px;display:inline-block;min-width:140px;width:100%;position:absolute;z-index:3;padding-top:8px}._3rpvMsaJx._2vvCoeLRx{background-color:#474747}._6PYfN0aWx{top:auto;bottom:100%}.Znl0bgh7x{left:auto;right:0}._1WIGlHoLx{width:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"minWidth": "140px",
	"dropdown": "_3ge6hWf8x",
	"header-container": "_5GeU6tVtx",
	"headerContainer": "_5GeU6tVtx",
	"dark": "_2vvCoeLRx",
	"header": "_6xm4GRsux",
	"search": "_6WDcsCKmx",
	"scrollable": "_4ybyHWpWx",
	"list": "_3rpvMsaJx",
	"upward": "_6PYfN0aWx",
	"right": "Znl0bgh7x",
	"portaled": "_1WIGlHoLx"
};
module.exports = exports;
